import React from "react";
import {
    IconCardHexagon,
    IconChipDepartment,
    PersonOutlinedChip
} from "../../../../../../components/buttons/IconButtons";
import { EMPTY_VALUES } from "../../../../../../Apis/functions";
import SummaryListCard from "../../../../../../components/Summary/SummaryListCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Departments container for the foodie shift summary. Thin wrapper over the
 * shared SummaryListCard with a total-employees chip per item.
 */
const SummaryContainerDepartments = ({ t, selected = [] }) => {

    const renderValue = (item) => (
        <div className={"col-12 d-flex justify-content-end align-items-baseline p-0 pr-3"}>
            <div className={"mr-8px"}><PersonOutlinedChip /></div>
            <p className={"fs-12px "}>{item?.totalEmployees ?? item?.employeeCount ?? EMPTY_VALUES.DEFAULT_NUMBER}</p>
        </div>
    );

    return (
        <SummaryListCard
            headerIcon={IconChipDepartment}
            title={t('departments')}
            emptyText={t('no_information_departments')}
            avatarIcon={IconCardHexagon}
            selected={selected}
            getLabel={(item) => item.fullName || item.name}
            renderValue={renderValue}
            t={t}
        />
    )

}

export default SummaryContainerDepartments
